module.exports = __webpack_public_path__ + "5908e88b298dd47b396f4a4b5552e420.svg";